export const GOOGLE_MAPS_API_LOADED = 'GOOGLE_MAPS_API_LOADED'

export const googleMapsApiLoaded = () => ({
  type: GOOGLE_MAPS_API_LOADED,
})
